import { Route, Routes, useParams } from 'react-router-dom';

import { paths, routes } from 'data/routes';

import { Manage } from 'sections/Manage';

import { Filters } from 'components/Filters';
import { Table } from 'components/Table';
import { TabType } from 'components/Tabs';

import * as S from '../Budget/components/List/List.styles';
import { useCustomerOrders } from './hooks/Orders.hook';
import { useNewOrder } from './hooks/useNewOrder';

export function Orders(): React.ReactElement {
  const paramsUrl = Object.values(useParams());
  const hasNew = paramsUrl.includes('new');
  const {
    reset,
    register,
    handleSubmit,
    onSubmit,
    setValue,
    control,
    params,
    filters,
    columns,
    currentOrders: data,
    isLoading,
  } = useCustomerOrders();
  const { newOrdersTabs } = useNewOrder();

  return (
    <Routes>
      <Route path="/">
        <Route
          index
          element={
            <>
              {!hasNew && (
                <S.CreateWrapper>
                  <S.Create
                    fontFamily="LFT Zeno Condensed"
                    iconLeft="FiPlus"
                    scale="lg"
                    asLink
                    to={`${routes.orders + routes.add}`}
                    motive="addNew"
                    textTransform="uppercase"
                  >
                    Add new order
                  </S.Create>
                </S.CreateWrapper>
              )}
              <Filters
                setValue={setValue}
                reset={reset}
                onSubmit={handleSubmit(onSubmit)}
                register={register}
                filters={filters}
                type="orders"
                control={control}
                defaultValues={params}
                isLoading={false}
              />
              <Table
                tableName="orders"
                isLoading={isLoading}
                hasPagination
                hasSort
                hasApiSorting
                columns={columns}
                data={data}
                initialSorting={[
                  {
                    id: 'createdAt',
                    desc: true,
                  },
                ]}
              />
            </>
          }
        />
      </Route>
      <Route
        path={paths.add}
        element={<Manage title="Add new order" tabs={newOrdersTabs} isNew />}
      />
    </Routes>
  );
}
